"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ApiTokensService", {
    enumerable: true,
    get: function() {
        return ApiTokensService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _catchError = require("~/helpers/catchError");
const _helpers = require("~/helpers");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ApiTokensService = class ApiTokensService {
    async apiTokenList(param) {
        var _param_req_user_extra, _param_req_user;
        // Check if user logged in via SSO
        const ssoClientId = (_param_req_user = param.req.user) == null ? void 0 : (_param_req_user_extra = _param_req_user.extra) == null ? void 0 : _param_req_user_extra.sso_client_id;
        if (ssoClientId) {
            // User logged in via SSO - show both SSO and normal tokens
            return await _models.ApiToken.list(param.userId);
        } else {
            // User logged in normally - only show non-SSO tokens
            return await _models.ApiToken.listForNonSsoUser(param.userId);
        }
    }
    async apiTokenCreate(param) {
        var _param_req_user_extra, _param_req_user, _param_tokenBody_description;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ApiTokenReq', param.tokenBody);
        // Get SSO client ID if user logged in via SSO
        const ssoClientId = (_param_req_user = param.req.user) == null ? void 0 : (_param_req_user_extra = _param_req_user.extra) == null ? void 0 : _param_req_user_extra.sso_client_id;
        param.tokenBody.description = (_param_tokenBody_description = param.tokenBody.description) == null ? void 0 : _param_tokenBody_description.trim();
        const token = await _models.ApiToken.insert(_extends({}, param.tokenBody, {
            fk_user_id: param.userId,
            fk_sso_client_id: ssoClientId || null
        }));
        this.appHooksService.emit(_nocodbsdk.AppEvents.API_TOKEN_CREATE, {
            userId: param.userId,
            tokenTitle: param.tokenBody.description,
            tokenId: token.id,
            req: param.req
        });
        return token;
    }
    async apiTokenDelete(param) {
        var _param_user;
        const apiToken = await _models.ApiToken.get(param.tokenId);
        if (!(0, _nocodbsdk.extractRolesObj)(param.user.roles)[_nocodbsdk.OrgUserRoles.SUPER_ADMIN] && apiToken.fk_user_id !== param.user.id) {
            _catchError.NcError.notFound('Token not found');
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.API_TOKEN_DELETE, {
            userId: (_param_user = param.user) == null ? void 0 : _param_user.id,
            tokenId: apiToken.id,
            tokenTitle: apiToken.description,
            req: param.req
        });
        // todo: verify token belongs to the user
        return await _models.ApiToken.delete(param.tokenId);
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
ApiTokensService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], ApiTokensService);
